export const getColor = (color?: string): string => {
  switch (color) {
    case 'Cinemark Red': return 'bg-primary text-white';
    case 'Dark Red': return 'bg-primary-darker text-white';
    case 'Black': return 'bg-black text-white';
    case 'White': return 'bg-white';
    default: return '';
  }
};
